import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { IAumyeState } from '../states/aumye.state';
import * as fromCalendarActions from '../actions/calendar.actions';
import * as fromDashboardActions from '../actions/dashboard.action';
import { catchError, mergeMap, of, switchMap, tap, withLatestFrom } from 'rxjs';
import { Router } from '@angular/router';
import { AumyeCalendarServiceService } from 'src/app/services/aumye-calendar-service.service';
import { ToastrService } from 'ngx-toastr';
import { MatDialog } from '@angular/material/dialog';

@Injectable()
export class CyclopsCalendarEffects {
  constructor(
    private actions$: Actions,
    private store: Store<IAumyeState>,
    private calendarServiceService: AumyeCalendarServiceService,
    private router: Router,
    private toastr: ToastrService,
    private dialog: MatDialog
  ) {}

  initVisitorCalendar$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromCalendarActions.InitVisitorCalendar>(
          fromCalendarActions.CalendarActionTypes.INIT_VISITOR_CALENDAR
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeCalendarState,
          action: action,
        })),
        tap(() => {
          this.router.navigateByUrl('dashboard/calendar');
        })
      ),
    { dispatch: false }
  );

  getCalendarDimensions$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromCalendarActions.GetCalendarDimensions>(
          fromCalendarActions.CalendarActionTypes.GET_CALENDAR_DIMENSIONS
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeCalendarState,
          action: action,
        }))
      ),
    { dispatch: false }
  );
  getTimeSlots$ = createEffect(() =>
    this.actions$.pipe(
      ofType<fromCalendarActions.GetTimeSlots>(
        fromCalendarActions.CalendarActionTypes.GET_TIME_SLOTS
      ),
      switchMap((action) => {
        let { payload } = action;
        return this.calendarServiceService.onGetTimeSlots({ ...payload }).pipe(
          mergeMap((res: any) => {
            return of(
              new fromCalendarActions.GetTimeSlotsSuccess(res)
              // new fromCalendarActions.GetHosts({})
            );
          }),
          catchError((err: any) =>
            of(new fromCalendarActions.GetTimeSlotsFailure(err))
          )
        );
      })
    )
  );
  GetTimeSlotsSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromCalendarActions.GetTimeSlotsSuccess>(
          fromCalendarActions.CalendarActionTypes.GET_TIME_SLOTS_SUCCESS
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeDashboardState,
          action: action,
        })),
        tap(
          ({
            state: {
              status: { isOrgUserDetailsLoaded },
              orgUserList,
            },
          }) => {
            // if (!isOrgUserDetailsLoaded)
            //   this.store.dispatch(new fromCalendarActions.GetHosts({}));
            // else
            //   this.store.dispatch(
            //     new fromCalendarActions.GetHostsSuccess(orgUserList)
            //   );
          }
        )
      ),
    { dispatch: false }
  );
  CheckExistingVisitor$ = createEffect(() =>
    this.actions$.pipe(
      ofType<fromCalendarActions.CheckExistingVisitor>(
        fromCalendarActions.CalendarActionTypes.CHECK_EXISTING_VISITOR
      ),
      withLatestFrom(this.store, (action, state) => ({
        state: state.aumyeCalendarState,
        action: action,
      })),
      switchMap(({ action: { payload } }) => {
        return this.calendarServiceService.onCheckVisitorExists(payload).pipe(
          mergeMap((res: any) => {
            return of(
              new fromCalendarActions.CheckExistingVisitorSuccess(payload)
            );
          }),
          catchError((err: any) =>
            of(new fromCalendarActions.CheckExistingVisitorFailure(err))
          )
        );
      })
    )
  );
  CheckExistingVisitorSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromCalendarActions.CheckExistingVisitorSuccess>(
          fromCalendarActions.CalendarActionTypes.CHECK_EXISTING_VISITOR_SUCCESS
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeCalendarState,
          action: action,
        })),
        tap(({ action: payload }) => {
          this.store.dispatch(
            new fromCalendarActions.CreateNewVisitorInvite(payload.payload)
          );
        })
      ),
    { dispatch: false }
  );
  CheckExistingVisitorFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromCalendarActions.CheckExistingVisitorFailure>(
          fromCalendarActions.CalendarActionTypes.CHECK_EXISTING_VISITOR_FAILURE
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeCalendarState,
          action: action,
        })),
        tap(({}) => {
          this.dialog.closeAll();
          this.toastr.error('Visitor Already Exists', 'Visitor', {
            closeButton: true,
            timeOut: 3500,
            progressBar: true,
            enableHtml: true,
            tapToDismiss: true,
          });
        })
      ),
    { dispatch: false }
  );
  getHosts$ = createEffect(() =>
    this.actions$.pipe(
      ofType<fromCalendarActions.GetHosts>(
        fromCalendarActions.CalendarActionTypes.GET_HOSTS
      ),
      switchMap((action) => {
        let { payload } = action;
        return this.calendarServiceService.onGetHostsList({ ...payload }).pipe(
          mergeMap((res: any) => {
            return of(new fromCalendarActions.GetHostsSuccess(res));
          }),
          catchError((err: any) =>
            of(new fromCalendarActions.GetHostsFailure(err))
          )
        );
      })
    )
  );
  initVisitorInvite$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromCalendarActions.InitVisitorInvite>(
          fromCalendarActions.CalendarActionTypes.INIT_VISITOR_INVITE
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeCalendarState,
          action: action,
        }))
      ),
    { dispatch: false }
  );
  createNewVisitorInvite$ = createEffect(() =>
    this.actions$.pipe(
      ofType<fromCalendarActions.CreateNewVisitorInvite>(
        fromCalendarActions.CalendarActionTypes.CREATE_NEW_VISITOR_INVITE
      ),
      withLatestFrom(this.store, (action, state) => ({
        state: state.aumyeCalendarState,
        action: action,
      })),
      switchMap((data: any) => {
        return this.calendarServiceService
          .onCreateNewVisitorInvite(data.action.payload)
          .pipe(
            mergeMap((res: any) => {
              return of(
                new fromCalendarActions.CreateNewVisitorInviteSuccess(res)
              );
            }),
            catchError((err: any) =>
              of(new fromCalendarActions.CreateNewVisitorInviteFailure(err))
            )
          );
      })
    )
  );
  createNewVisitorInviteSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromCalendarActions.InitVisitorInvite>(
          fromCalendarActions.CalendarActionTypes
            .CREATE_NEW_VISITOR_INVITE_SUCCESS
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeCalendarState,
          action: action,
        })),
        tap(() => {
          this.store.dispatch(new fromDashboardActions.UpdateVisitorList({}));
          this.dialog.closeAll();
          this.toastr.success('Invite Created', 'Pre-Verified', {
            closeButton: true,
            timeOut: 1500,
            progressBar: true,
            enableHtml: true,
            tapToDismiss: true,
          });
        })
      ),
    { dispatch: false }
  );
  createNewVisitorInviteFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromCalendarActions.InitVisitorInvite>(
          fromCalendarActions.CalendarActionTypes
            .CREATE_NEW_VISITOR_INVITE_FAILURE
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeCalendarState,
          action: action,
        })),
        tap((state) => {
          this.toastr.error(`${state.action.payload.global}`);
          this.dialog.closeAll();
        })
      ),
    { dispatch: false }
  );
  HostVisitorVerify$ = createEffect(() =>
    this.actions$.pipe(
      ofType<fromCalendarActions.HostVisitorVerify>(
        fromCalendarActions.CalendarActionTypes.HOST_VISITOR_VERIFY
      ),
      withLatestFrom(this.store, (action, state) => ({
        state: state.aumyeCalendarState,
        action: action,
      })),
      switchMap((data: any) => {
        return this.calendarServiceService
          .onVerifyHostVisitor(data.action.payload)
          .pipe(
            mergeMap((res: any) => {
              return of(new fromCalendarActions.HostVisitorVerifySuccess(res));
            }),
            catchError((err: any) =>
              of(new fromCalendarActions.HostVisitorVerifyFailure(err))
            )
          );
      })
    )
  );
}
